import { useConfig } from "../../../contexts/ConfigContext"
import React, { useEffect, useState } from "react"
import { Button, message, TableColumnsType } from "antd"
import TableView from "../TableView"
import useAuth from "../../../hooks/useAuth"
import { ColumnType } from "antd/es/table"
import { SearchOutlined } from "@ant-design/icons"
import { useStore } from "../../../contexts/StoreContext"
import { useCompany } from "../../../contexts/CompanyContext"
import { usePos } from "../../../contexts/PosContext"
import PosModal from "../../modals/PosModal"
import { usePosFetch } from "../../../hooks/useSale"
import { useStoreFetch } from "../../../hooks/useInventory"

function ViewPosItemList(){
  const { config } = useConfig()
  const {pos,updatePos} = usePos()
  const {store,updateStore} = useStore()
  const {company} = useCompany()
  const [spinning, setSpinning] = useState(false)
  const [skeleton, setSkeleton] = useState(true)
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:posData} = usePosFetch(tokenData,{
    all:true,
    company:company.current.uid,
  },company.current.id)
  const {data:storeData} = useStoreFetch(tokenData,{
    all:true,
    company:company.current.uid,
  })
  useEffect(()=>{
    if(posData !== undefined && storeData !== undefined){
      updatePos({list: posData.pos ?? []})
      updateStore({list: storeData.storehouse ?? []})
      setSkeleton(false)
    }
  },[posData,storeData,pos.currentItem])
  //console.log('Load content ',companies.current)
  let title = 'Puntos de venta'
  let emptyMessage = 'Aun no has agregado puntos de venta'

  const handleClick = async (data:any,index:any) => {
    setSpinning(true)
    updatePos({showModal:true,currentItem:data})
    setSpinning(false)
  }

  // Columnas de la tabla con búsqueda
  const filterIconElement = (filtered:boolean) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  const getColumnSearchProps = (dataIndex: string): ColumnType => ({
    /*
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button onClick={() => handleReset(clearFilters,confirm)} size="small" style={{ width: 90 }}>
            Limpiar
          </Button>
        </Space>
      </div>
    ),*/
    filterIcon: filterIconElement,
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toString().toLowerCase())
  });

  const tableColumns:TableColumnsType = [
    {title: "#",dataIndex:"register",width:50},
    {title: "Nombre",dataIndex:"name",ellipsis:true,
      sorter:(a,b)=>a.name.localeCompare(b.name),
      ...getColumnSearchProps('name')},
    {title: "ID",dataIndex:"alias",ellipsis:true,
      sorter:(a,b)=>a.alias.localeCompare(b.alias),
      ...getColumnSearchProps('alias')},
    {title: "Almacén", dataIndex: "storehouse_name"},
    {title: "Creado",dataIndex:"created_at",render:(text)=>new Date(text).toLocaleString()},
  ]

  const dataTable = pos?.list?.map((el,i)=>{
    const register = i + 1
    const key = i 
    return {...el,register,key}
  })
  const handleButtonClick = () => {
    if(!store.list?.length){
      return message.error('No hay almacenes registrados')
    }
    updatePos({showModal:true,currentItem:undefined})
  }
  const footerElement = () => <Button type="primary" onClick={handleButtonClick} htmlType="button">Crear PDV</Button>

  return (
    <TableView
      title={title}
      spinning={spinning}
      skeleton={skeleton}
      tableColumns={tableColumns}
      dataTable={dataTable}
      modal={PosModal}
      footerElement={footerElement}
      onRow={(data:any,index:any) => {return{onClick:()=>handleClick(data,index),style:{cursor:"pointer"}}}}
      emptyMessage={emptyMessage}>
    </TableView>
  )
}

export default ViewPosItemList